import { gql } from "@grandvisionhq/graphql";
import { cartFailures, cartValidationErrors } from "../../../../fragments/CartButton/operations/fragments/cart-validation-errors.js";
const GET_TOTAL_LINE_ITEMS = gql`
  query GetTotalLineItems($id: ID!) {
    cart(id: $id) {
      cart {
        id
        numberOfItems
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      failures {
        ...CartFailuresFragment
      }
    }
  }
  ${cartFailures}
  ${cartValidationErrors}
`;
export {
  GET_TOTAL_LINE_ITEMS
};
//# sourceMappingURL=get-total-line-items.js.map
